import React from "react";
import "../components/MacWindow.css";
import Draggable from "react-draggable";
import PropTypes from "prop-types";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import Container from "react-bootstrap/Container";
import npm from "../images/projects/npm.png";
import restapi from "../images/projects/restapi.png";
import folder from "../images/icons/folder.png";
// Tab Panel
function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`vertical-tabpanel-${index}`}
      aria-labelledby={`vertical-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};
export default function Settings({ onClose }) {
  const [value, setValue] = React.useState(0);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  return (
    <Draggable handle=".windowheader">
      <div className="draggable-container">
        <div class="window projects">
          <div class="windowheader">
            <div class="wrapper">
              <div class="nav-buttons">
                <div class="close" onClick={onClose}></div>
                <div class="minimize"></div>
                <div class="expand"></div>
              </div>
              <div class="title">Projects</div>
            </div>
          </div>

          <div class="body projects">
            <Box
              sx={{
                flexGrow: 1,
                bgcolor: "background.paper",
                display: "flex",
                height: 500,
              }}
            >
              <Tabs
                orientation="vertical"
                variant="scrollable"
                value={value}
                onChange={handleChange}
                aria-label="Vertical tabs example"
                sx={{ borderRight: 1, borderColor: "divider" }}
              >
                <Tab label="Domain" />
                <Tab label="UI/UX" />
                <Tab label="Front-End" />
                <Tab label="Back-End" />
                <Tab label="Portfolio" />
                <Tab label="Python" />
              </Tabs>
              <TabPanel value={value} index={0}>
                <img src={folder} alt="Folder-icon" className="project-home"/>
              </TabPanel>
              <TabPanel value={value} index={1}>
                <Container
                  style={{ maxHeight: "465px", overflowX: "hidden" }}
                  id="style-1"
                  className="scrollbar"
                >
                  <h2 className="project-title">Landing Page</h2>
                  <iframe
                    style={{ border: "1px solid rgba(0, 0, 0, 0.1)" }}
                    src="https://www.figma.com/embed?embed_host=share&url=https%3A%2F%2Fwww.figma.com%2Fproto%2FplUpf2OK7nEUW83UfI7W07%2FLanding-Page%3Fnode-id%3D1-2%26t%3DgrjF6AmzMI3NHeCp-1%26scaling%3Dcontain%26page-id%3D0%253A1"
                    allowFullScreen=""
                  />
                  <p>(Takes time to load the figma)</p>
                  <h2 className="project-title">Checkout Page</h2>
                  <iframe
                    style={{ border: "1px solid rgba(0, 0, 0, 0.1)" }}
                    src="https://www.figma.com/embed?embed_host=share&url=https%3A%2F%2Fwww.figma.com%2Fproto%2FGl0IJCeu6EdRNQAoSYxZgC%2FCheckout-Page%3Ft%3DvrY8KZduc5RcRu3W-1%26scaling%3Dcontain%26page-id%3D0%253A1%26node-id%3D1-2"
                    allowFullScreen=""
                  />
                  <h2 className="project-title">Sign In Page</h2>
                  <iframe
                    style={{ border: "1px solid rgba(0, 0, 0, 0.1)" }}
                    src="https://www.figma.com/embed?embed_host=share&url=https%3A%2F%2Fwww.figma.com%2Fproto%2FzHxKkyaVioSCwb9Pfpn9Z3%2FSign-up-Page%3Ft%3DlEjgt4CRrR89tCOs-1%26scaling%3Dcontain%26page-id%3D0%253A1%26node-id%3D3-34%26starting-point-node-id%3D3%253A34"
                    allowFullScreen=""
                  />
                </Container>
              </TabPanel>
              <TabPanel value={value} index={2}>
                <Container
                  style={{ maxHeight: "465px", overflowX: "hidden" }}
                  id="style-1"
                  className="scrollbar"
                >
                  <h2 className="project-title">Open Source Galaxy</h2>
                  <iframe
                    style={{ border: "1px solid rgba(0, 0, 0, 0.1)" }}
                    src="https://opensourcegalaxy.wiki/"
                    allowFullScreen=""
                  />
                  <p className="project-description">
                    Open Source Galaxy is a platform designed to keep
                    open-source enthusiasts up-to-date with the latest event
                    registration openings. Users can easily access information
                    about upcoming events and ensure they never miss an
                    opportunity to participate.
                  </p>
                  <h2 className="project-title">Cyber Nexus</h2>
                  <iframe
                    style={{ border: "1px solid rgba(0, 0, 0, 0.1)" }}
                    src="https://rupa-rd.github.io/Cyber_Nexus/"
                    allowFullScreen=""
                  />
                  <p className="project-description">
                    The project is a website that provides free cybersecurity
                    courses to learners of all levels. The website will be
                    designed to provide an accessible and comprehensive platform
                    for individuals who may not have the financial means to
                    enroll in traditional educational programs.
                  </p>
                </Container>
              </TabPanel>
              <TabPanel value={value} index={3}>
                <Container
                  style={{ maxHeight: "465px", overflowX: "hidden" }}
                  id="style-1"
                  className="scrollbar"
                >
                  <h2 className="project-title">Book Catalog RestAPI</h2>
                  <a href="https://bookcatalog-restapi.onrender.com/bookStack">
                    <img
                      src={restapi}
                      height="300px"
                      width="600px"
                      style={{ border: "1px solid rgba(0, 0, 0, 0.1)" }}
                    />
                  </a>
                  <p className="project-description">
                  Developed a Restful API for managing book data, resulting in a 25% increase in data management efficiency for the team 
                  Utilized Node, Express for backend, MongoDB to store book data and deployed on Render that allows CRUD operations 
                  </p>
                  <h2 className="project-title">Create-front-end-app-html</h2>
                  <a href="https://www.npmjs.com/package/create-front-end-app-html">
                    <img
                      src={npm}
                      height="300px"
                      width="600px"
                      style={{ border: "1px solid rgba(0, 0, 0, 0.1)" }}
                    />
                  </a>
                  <p className="project-description">
                    Creates a front-end app template with necessary files and
                    folders. Which includes Html, CSS and Java Script files. You
                    can use create-front-end-app-html command to create a
                    templates of a front-end project inside a main project
                    folder. You can use the below command to create a front-end
                    app template.
                  </p>
                </Container>
              </TabPanel>
              <TabPanel value={value} index={4}>
                <iframe
                  style={{ border: "1px solid rgba(0, 0, 0, 0.1)" }}
                  src="https://rupa-rd.github.io/portfolio.rd/"
                  className="portfolio"
                  allowFullScreen=""
                />
              </TabPanel>
              <TabPanel value={value} index={5}>
                <h2 className="project-title">Text Summarizer Using Bart and Gradio</h2>
                <iframe
                  src="https://rupa23-gradio-text-summarizer.hf.space"
                  frameborder="0"
                  style={{ border: "1px solid rgba(0, 0, 0, 0.1)" }}
                />
              </TabPanel>
            </Box>
          </div>
          {/* <footer>
        <p>Developed by Rd</p>
    </footer> */}
        </div>
      </div>
    </Draggable>
  );
}
